import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../../store/reducers/preferences';
import {useSettingsStyles} from '../userProperties';
import {FormLabel} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {isNull} from 'lodash';
import AgyleSwitch from '../../../ui/switch/agyleSwitch';

const DEFAULT_STATE = {
    showSnomedCode: true,
};

const ShowSnomedCode = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [show, setShow] = useState(!isNull(agylePreference?.showSnomedCode) ? agylePreference?.showSnomedCode : DEFAULT_STATE.showSnomedCode);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setShow(DEFAULT_STATE.showSnomedCode);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (__, val) => {
        setShow(val);
        props.onChange('showSnomedCode', val);
    };

    return (
        <div className={classes.divRow} style={{gap: 20}}>
            <FormLabel>
                {t('Show SNOMED Code')}
            </FormLabel>

            <AgyleSwitch
              onChange={handleChange}
              value={show}
            />
        </div>
    );
});

export default ShowSnomedCode;